import React, { ReactNode } from "react";
import { setDropzoneRef } from "@lib/dropzoneRef";
import {
    EntityLogoUploadContextValue,
    useEntityLogoUpload,
} from "./entityLogoUpload.context";

interface Props {
    children:
        | ReactNode
        | ((open: EntityLogoUploadContextValue["open"]) => ReactNode);
}

export const EntityLogoUpload: React.FC<Props> = ({ children }) => {
    const { open, inputProps } = useEntityLogoUpload();

    return (
        <>
            {typeof children === "function" ? children(open) : children}
            <input
                {...inputProps}
                className="d-none"
                data-testid="entity-logo-upload-input"
                ref={(el) => setDropzoneRef(inputProps, el)}
            />
        </>
    );
};
